import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
const PDPInfoTable = t0 => {
  const $ = _c(11);
  const {
    items: t1,
    loading: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const loading = t2 === undefined ? false : t2;
  if (loading) {
    let t4;
    if ($[2] !== loading) {
      t4 = classNames("flex flex-col mx-0 my-4 w-full", {
        "!my-2": loading
      });
      $[2] = loading;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = [0, 1, 2, 3, 4].map(_temp);
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== t4) {
      t6 = <div className={t4}>{t5}</div>;
      $[5] = t4;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t4;
  if ($[7] !== items) {
    t4 = items.map(_temp2);
    $[7] = items;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="flex flex-col mx-0 my-4 w-full">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
PDPInfoTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  loading: PropTypes.bool
};
export default PDPInfoTable;
function _temp(key) {
  return <div key={key} className="items-start flex justify-between px-0 py-[.4rem] w-full"><Placeholder loading={true} type="rect" style={{
      marginRight: 0,
      height: "26px"
    }} /></div>;
}
function _temp2(t0) {
  const {
    label,
    value
  } = t0;
  if (!`${value}`.includes("undefined")) {
    return <div key={label} className="items-start [border-bottom:1px_solid_#f1f1f1] flex justify-between px-0 py-[.4rem] w-full last:[border-bottom:0]"><div className="text-gray font-bold text-sm">{label}</div><div className="text-gray text-sm max-w-[200px] text-right">{value}</div></div>;
  }
  return null;
}